// import React from 'react'
// import {Link}  from 'react-router-dom'
// import Logo from '../../images/logo/maak-dream-logo.png'
// import Projects from '../../api/project'



// const Footer = (props) => {

//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }

//     return (
//         <footer className={`wpo-site-footer ${props.ftClass}`}>
//             <div className="wpo-upper-footer">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
//                             <div className="widget about-widget">
//                                 <div className="logo widget-title">
//                                     <Link onClick={ClickHandler} className="logo" to="/"><img src={Logo} alt="" /></Link>
//                                 </div>
//                             <p>MAAKDREAM is the real estate brand of the future, born from the legacy of MAAKSONS Engineering Corporation Ltd. With over 70 years of experience in delivering national megaprojects, we bring engineering excellence to lifestyle development in Dubai.</p>
//                             <ul>
//                                 <li>
//                                     <a href="https://www.facebook.com/profile.php?id=61577496941339" target="_blank" rel="noopener noreferrer">
//                                         <i className="ti-facebook"></i>
//                                     </a>
//                                 </li>
//                                 <li>
//                                     <a href="https://www.instagram.com/maakdreamproperties/" target="_blank" rel="noopener noreferrer">
//                                         <i className="ti-instagram"></i>
//                                     </a>
//                                 </li>
//                             </ul>
//                             </div>

//                             {/* <p>MAAKDREAM is the real estate brand of the future, born from the legacy of MAAKSONS Engineering Corporation Ltd. With over 70 years of experience in delivering national megaprojects, we bring engineering excellence to lifestyle development in Dubai.</p>
//                             <ul>
//                                 <li>
//                                     <a href="https://www.facebook.com/profile.php?id=61577496941339" target="_blank" rel="noopener noreferrer">
//                                         <i className="ti-facebook"></i>
//                                     </a>
//                                 </li>
//                                 <li>
//                                     <a href="https://www.instagram.com/maakdreamproperties/" target="_blank" rel="noopener noreferrer">
//                                         <i className="ti-instagram"></i>
//                                     </a>
//                                 </li>
//                             </ul> */}

//                         </div>
//                         <div className="col col-xl-1  col-lg-4 col-md-6 col-sm-12 col-12">
//                             {/* <div className="widget link-widget">
//                             <div className="widget-title">
//                                 <h3>Our Services</h3>
//                             </div>
//                             <ul>
//                                 <li><Link onClick={ClickHandler} to="/service-single">Perfect Planning</Link></li>
//                                 <li><Link onClick={ClickHandler} to="/service-single">Profesional Design</Link></li>
//                                 <li><Link onClick={ClickHandler} to="/service-single">Best Interior</Link></li>
//                                 <li><Link onClick={ClickHandler} to="/service-single">Modern Furniture</Link></li>
//                                 <li><Link onClick={ClickHandler} to="/service-single">Complete Decoration</Link></li>
//                             </ul>
//                         </div> */}
//                         </div>
//                         <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
//                             <div className="widget wpo-service-link-widget">
//                                 <div className="widget-title">
//                                     <h3>Contact </h3>
//                                 </div>
//                                 <div className="contact-ft">
//                                     <ul>
//                                         <li><i className="fi flaticon-location"></i>205, 2020 Building Sheikh Zayed Road Dubai</li>
//                                         <li><i className="fi flaticon-telephone"></i>04 5546928 | 055 8690761</li>
//                                         <li><i className="fi flaticon-email"></i>info@maakdream.com</li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
//                             <div className="widget instagram">
//                                 <div className="widget-title">
//                                     <h3>Our Gallery</h3>
//                                 </div>
//                                 <ul className="d-flex">
//                                     {Projects.slice(0, 6).map((project, pot) => (
//                                         <li key={pot}><Link onClick={ClickHandler} to={`/project-single/${project.Id}`}><img src={project.pImg} alt="" /></Link></li>
//                                     ))}
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="wpo-lower-footer">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col col-xs-12">
//                             <ul>
//                                 <li>&copy; 2024 MAAKDREAM. All Rights Reserved.</li>
//                                 <li><Link onClick={ClickHandler} to="/">Terms of use |</Link> <Link onClick={ClickHandler} to="/">Privacy Environmental Policy</Link></li>
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </footer>
//     )
// }

// export default Footer;





















import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFooter } from "../../api/Home";

const Footer = ({ ftClass }) => {
    const [footer, setFooter] = useState(null);

    useEffect(() => {
        const fetchFooter = async () => {
            const data = await getFooter();
            setFooter(data);
        };
        fetchFooter();
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    if (!footer) return null;

    return (
        <footer className={`wpo-site-footer ${ftClass}`}>
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">

                        {/* About Section */}
                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <Link onClick={ClickHandler} className="logo" to={footer.logo_button_link}>
                                        <img src={footer.logo} alt="logo" />
                                    </Link>
                                </div>

                                <p>{footer.about_text}</p>

                                <ul>
                                    {footer.facebook_url && (
                                        <li>
                                            <a href={footer.facebook_url} target="_blank" rel="noopener noreferrer">
                                                <i className="ti-facebook"></i>
                                            </a>
                                        </li>
                                    )}
                                    {footer.instagram_url && (
                                        <li>
                                            <a href={footer.instagram_url} target="_blank" rel="noopener noreferrer">
                                                <i className="ti-instagram"></i>
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>

                        {/* Empty Column — keep layout intact */}
                        <div className="col col-xl-1 col-lg-4 col-md-6 col-sm-12 col-12"></div>

                        {/* Contact Section */}
                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget wpo-service-link-widget">
                                <div className="widget-title">
                                    <h3>{footer.contact}</h3>
                                </div>
                                <div className="contact-ft">
                                    <ul>
                                        <li><i className="fi flaticon-location"></i>{footer.address}</li>
                                        <li><i className="fi flaticon-telephone"></i>{footer.phone_numbers}</li>
                                        <li><i className="fi flaticon-email"></i>{footer.email}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Gallery Section */}
                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget instagram">
                                <div className="widget-title">
                                    <h3>{footer.gallery_heading}</h3>
                                </div>

                                <ul className="d-flex">
                                    {[1, 2, 3, 4, 5, 6].map((i) => {
                                        const img = footer[`gallery_image_btn${i}`];
                                        const link = footer[`gallery_image_link${i}`];

                                        return (
                                            img && (
                                                <li key={i}>
                                                    <a href={link} rel="noopener noreferrer">
                                                        <img src={img} alt={`gallery-${i}`} />
                                                    </a>
                                                </li>
                                            )
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Bottom Footer */}
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: footer.copyright_text }} />

                                <li>
                                    {footer.terms_link && (
                                        <a href={footer.terms_link} target="_blank" rel="noopener noreferrer">Terms of Use | </a>
                                    )}
                                    {footer.privacy_link && (
                                        <a href={footer.privacy_link} target="_blank" rel="noopener noreferrer">Privacy Environmental Policy</a>
                                    )}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
